/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Renderer2, RendererFactory2, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

import { Iceutility } from '../../services/iceutility';
import { LoginService } from '../../login/login.service';
import { LoginConfig } from '../../login/login.config';
import { environment } from "../../../../../src/environments/environment";
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { messagereference } from '../../../../icemedx-lib/src/models/messages/messagereference';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { user } from '../../models/common/user';
import { message } from '../../models/messages/message';
import { DomainService } from '../../services/domain/domain.service';

export class menuItem {
    id: string;
    parentId: string;
    routeUrl: string;
    text: string;
    iconClassToAdd: string;
    routeUrlOverride: string;
}

declare var require: any;
// 1/7/2023 To do for multiple product support
// product_server: string = "";
let ehr_server: string = "";
let app_path: string = "";
let currentEnv: any = require("../../../../../env.json").currentEnv;
let envs: any = require("../../../../../env.json").environments;
if (envs != null) {
  app_path = envs[currentEnv].app_path;
  //if (location.hostname indexof ehr || hhc)
  //product_server = envs[currentEnv].ehr_server;  change to product_server
  ehr_server = envs[currentEnv].ehr_server;
}

console.log("Nav. Svc. App: " + app_path);

@Injectable()
export class IceNavService {
    private lastNumberOfUnreadMessages: number = 0;
    private renderer: Renderer2;
    sideMenus: menuItem[] = [];
    sideLookup: any = {};

  public sideMenuParentElementID: string = "routeItems";
  public sideMenuTogglerParentElementID: string = "routeItemToggler";
  public topMenuMessageItemsElementID: string = "messageItems";
  public topMenuMessagesParentElementID: string = "messages";
  public topMenuAlertsParentElementID: string = "alerts";
  public topMenuSearchParentElementID: string = "search";
  public topMenuLogoutParentElementID: string = "logout";
  public topMenuMessageBadgeId = "messagesBadge"

    private unReadMessagesReadySbj = new Subject<messagereference[]>();

    constructor(private domainService: DomainService, private loginSvc: LoginService, private msgService: MessageService, rendererFactory: RendererFactory2, private router: Router) {
      this.renderer = rendererFactory.createRenderer(null, null);
    }

  onUnReadMessageReady(): Observable<messagereference[]> {
      return this.unReadMessagesReadySbj.asObservable();
    }

    getUnreadMessageCount(): number {
      return this.lastNumberOfUnreadMessages;
    }

  setNavOn(on: boolean) {
    let nav: HTMLElement = document.getElementById("navbarResponsive");
    if (nav == null) return;

    let navTgl: HTMLElement = document.getElementById("mainNavToggle");
    let navTop: HTMLElement = document.getElementById("mainNavTop");
    //routeItems
    //routeItemToggler

    if (on) {
      nav.style.display = "block";
      if (navTgl) navTgl.style.display = "block";
      if (navTop) navTop.style.display = "block";
    }
    else {
      nav.style.display = "none";
      if (navTgl) navTgl.style.display = "none";
      if (navTop) navTop.style.display = "none";
    }
  }

  getSideMenuItems(): menuItem[] {
    return this.sideMenus;
  }

    refresh() {
      let userInfo = this.loginSvc.GetSessionUserInfo();
      if (!this.loginSvc.IsSignedIn(userInfo)) { 
          this.removeAllSideRoutes();

          this.showTopMenuParent(this.topMenuMessagesParentElementID, false);
          this.showTopMenuParent(this.sideMenuTogglerParentElementID, false);
          this.showTopMenuParent(this.topMenuAlertsParentElementID, false);
          this.showTopMenuParent(this.topMenuSearchParentElementID, false);
          this.showTopMenuParent(this.topMenuLogoutParentElementID, false);
          return ;
      }

      this.removeAllSideRoutes();

      this.showTopMenuParent(this.topMenuMessagesParentElementID, true);
      this.showTopMenuParent(this.sideMenuTogglerParentElementID, true);
      this.showTopMenuParent(this.topMenuAlertsParentElementID, true);
      this.showTopMenuParent(this.topMenuSearchParentElementID, true);
      this.showTopMenuParent(this.topMenuLogoutParentElementID, true);

      for (let itm of this.sideMenus) {
          this.renderSideRoute(itm);
      }
      
      let parent: HTMLElement = document.getElementById(this.topMenuMessageItemsElementID);
      if (parent != null) {
        parent.innerHTML = "";
      }

      this.msgService.getMessages(IceTypes.MessageboxTypes.mboxINBOX, IceTypes.trans_status.isUnRead).subscribe(data => {
        if (data) {
          let membersToMap = {}
          this.lastNumberOfUnreadMessages += data.length;
          let messages = data;
          let count: number = 1;
          for (let index in messages) {
            if (count > 3) break;

            let msg: messagereference = messages[index];
            if (!Iceutility.isdefined(msg)) {
              continue;
            }

            let memid = msg.from.toLowerCase();
            if (membersToMap[memid] == null)
              membersToMap[memid] = [];

            membersToMap[memid].push(msg);
            this.insertMessage(msg, this.topMenuMessageItemsElementID, LoginConfig.getFormattedPath(app_path, "viewmessage/" + msg.message_key));
            count++;
          }
          this.unReadMessagesReadySbj.next(messages);

          let mems = Object.keys(membersToMap);
          if (mems.length > 0) {
            let memList = mems.join(",");
            this.domainService.mapMembers(memList).subscribe(
              response => {
                for (let index = 0; index < response.length; index++) {
                  let mappedMember: user = response[index];
                  if (mappedMember == null) continue;

                  let memid = mappedMember.login_user_name.toLowerCase();
                  let displayName = mappedMember.getdisplayname();
                  let msgAry = membersToMap[memid];
                  if (msgAry) {
                    for (let imsg = 0; imsg < msgAry.length; imsg++) {
                      if (msgAry[imsg] == null) continue;
                      this.updateMessageFrom(msgAry[imsg], this.topMenuMessageItemsElementID, LoginConfig.getFormattedPath(app_path, "viewmessage/" + msgAry[imsg].message_key), displayName);
                    }
                  }
                }
              });
          }
        }
      });

      this.msgService.getMessages(IceTypes.MessageboxTypes.mboxINVITE, IceTypes.trans_status.isUnRead)
        .subscribe(data => {
        if (data) {
          this.lastNumberOfUnreadMessages += data.length;
        }
        });

      if (location.hostname.indexOf("qa.") == 0 || location.hostname.indexOf("dev.") == 0 || location.hostname.indexOf("localhost") == 0) {
        this.msgService.logMessage(IceTypes.LOGTYPE.ltWarning, "You are accessing the testing site.");
        setTimeout(function () {
          let elem: HTMLElement = document.querySelector(".alert-warning .close");
          if (elem) {
            elem.click();
          }
        }, 10000);
      }
    }

    insertSideRoute(userInfo: any, id: string, parentId: string, routeUrl: string, text: string, iconclassToAdd: string, index: number, routeUrlOverride: string = null): menuItem {
        let item: menuItem = null;
        try {
            if (id != null && id != "" && this.sideLookup[id] != null) return this.sideLookup[id];

            if (id == "" || id == null) id = Iceutility.guid(false);
            item = new menuItem();
            item.id = id;
            item.parentId = parentId;
            if (routeUrlOverride != null) {
              item.routeUrl = "";
              item.routeUrlOverride = routeUrlOverride;
            }
            else {
              item.routeUrl = LoginConfig.getFormattedPath(app_path, routeUrl);
            }
            
            item.iconClassToAdd = iconclassToAdd;
            item.text = text;
            this.sideMenus.push(item);

            this.sideLookup[id] = item;
            return item;
        } catch (e) {
            console.log(e);
        }

        return null;
    }

    renderSideRoute(item: menuItem): boolean {
        try {
            if (item == null) throw "Error: Invalid render parameter.";

            let existingEl: HTMLElement = document.getElementById(item.id);
            if (existingEl != null) return true;

            let parentId = item.parentId;
            if (parentId == null || parentId == "") parentId = this.sideMenuParentElementID; 

            let parent: HTMLElement = document.getElementById(parentId);
            if (parent == null) throw "Error: Parent menu (" + parentId + ") item not present in DOM.";

            let liItem: HTMLLIElement = this.renderer.createElement("li");
            this.renderer.setAttribute(liItem, "id", item.id);
            this.renderer.setAttribute(liItem, "data-toggle", "tooltip");
            this.renderer.setAttribute(liItem, "data-placement", "right");
            this.renderer.setAttribute(liItem, "title", item.text);
            this.renderer.addClass(liItem, "nav-item");

            let anchor: HTMLAnchorElement = this.renderer.createElement("a");
            this.renderer.setAttribute(anchor, "href", item.routeUrl);
            this.renderer.addClass(anchor, "nav-link");

            this.renderer.listen(anchor, 'click', (evt) => {
              if (item.routeUrlOverride != null) {
                let tourl: string = this.buildRoute(item.routeUrlOverride, true);
                location.href = tourl;
              }
              else {
                this.router.navigate([item.routeUrl]);
              }
            });

            let iEl: HTMLElement = this.renderer.createElement("i");
            if (item.iconClassToAdd != "" && item.iconClassToAdd != null) {
                for (let cls of item.iconClassToAdd.split(" "))
                    this.renderer.addClass(iEl, cls);
            }
            this.renderer.appendChild(anchor, iEl);

            let span: HTMLSpanElement = this.renderer.createElement("span");
            this.renderer.addClass(span, "nav-link-text");
            span.textContent = " " + item.text;
            this.renderer.appendChild(anchor, span);

            this.renderer.appendChild(liItem, anchor);
            this.renderer.appendChild(parent, liItem);
            return true;
        } catch (e) {
            console.log(e);
        }

        return false;
    }

    removeAllSideRoutes() {
        try {
            let parentId = this.sideMenuParentElementID;
            let parent: HTMLElement = document.getElementById(parentId);
            if (parent == null) throw "Error: Parent menu (" + parentId + ") item not present in DOM.";

            let list: any = []; 
            for (let nd = 0; nd < parent.childNodes.length; nd++) {
                let node = parent.childNodes[nd];
                list.push(node);
            }

            for (let node of list) {
                parent.removeChild(node);
            }
        } catch (e) {
            console.log(e);
        }
    }

    showTopMenuParent(id: string, hide: boolean) {
        try {
            let parent: HTMLElement = document.getElementById(id);
            if (parent == null) throw "Error: Parent menu (" + id + ") item not present in DOM.";
            this.renderer.setStyle(parent, "display", hide ? "normal" : "none");
        } catch (e) {
            console.log(e);
        }
    }

  hideSideMenu(hide: boolean): void {
    try {
      let parentId = this.sideMenuParentElementID;
      let parent: HTMLElement = document.getElementById(parentId);
      if (parent == null) throw "Error: Parent menu (" + parentId + ") item not present in DOM.";

      this.renderer.setStyle(parent, "display", hide ? "none" : "normal");

      let parentToggler: HTMLElement = document.getElementById(this.sideMenuTogglerParentElementID);
      if (parentToggler != null) this.renderer.setStyle(parentToggler, "display", hide ? "none" : "normal");;
    } catch (e) {
      console.log(e);
    }
  }

    setAllMessages(routeUrl: string) {
      try {
        let allmsg: HTMLElement = document.getElementById("allMessages");
        if (allmsg == null) throw "Error: All message menu item not present in DOM.";
        this.renderer.setAttribute(allmsg, "href", LoginConfig.getFormattedPath(app_path, routeUrl));
      } catch (e) {
        console.log(e);
      }
    }

    // To do
    // messages - 
    // messagesDropdown
    // messagesBadge
    // messageItems - insertMessageTopMenu
        //<a class="dropdown-item" href = "#" >
        //<strong>David Miller </strong>
        //<span class="small float-right text-muted">11: 21 AM</span>
        //<div class="dropdown-message small"> Hey there! This new version of SB Admin is pretty awesome! These messages clip off when they reach the end of the box so they don't overflow over to the sides!</div>
        //</a>
        //<div class="dropdown-divider"> </div>

    insertMessage(msg: messagereference, parentId: string, routeUrl: string): boolean {
      try {
        if (msg == null) throw "Message Reference is null.";

        let messageBadgeElem = document.getElementById(this.topMenuMessageBadgeId);
        if (messageBadgeElem) {
          messageBadgeElem.innerHTML = this.getUnreadMessageCount().toString();
        }

        let parent: HTMLElement = document.getElementById(parentId);
        if (parent == null) throw "Error: Parent menu (" + parentId + ") item not present in DOM.";

        let container: HTMLDivElement = document.createElement("div");
        this.renderer.addClass(container, "message-container");
        this.renderer.appendChild(parent, container);

        let anchor: HTMLAnchorElement = this.renderer.createElement("a");
        this.renderer.setAttribute(anchor, "href", routeUrl);
        this.renderer.setAttribute(anchor, "id", "Route" + msg.message_key);
        this.renderer.addClass(anchor, "dropdown-item");

        this.renderer.listen(anchor, 'click', (evt) => {
          var na1 = document.querySelectorAll(".navbar-collapse");
          for (var j = 0; j < na1.length; j++) {
            na1[j].classList.remove("show");
          }

          this.router.navigate([routeUrl]);
        });

        let strongEl: HTMLElement = this.renderer.createElement("strong");
        this.renderer.setAttribute(strongEl, "id", "From" + msg.message_key);
        strongEl.textContent = msg["from"];
        this.renderer.appendChild(container, strongEl);

        let span: HTMLSpanElement = this.renderer.createElement("div");
        this.renderer.addClass(span, "small");
        this.renderer.addClass(span, "text-muted");
        span.textContent = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(msg["message_date"]));
        this.renderer.appendChild(container, span);

        this.renderer.appendChild(container, anchor);

        let divItem: HTMLDivElement = this.renderer.createElement("div");
        this.renderer.addClass(divItem, "dropdown-message");
        this.renderer.addClass(divItem, "small");
        divItem.textContent = msg["subject"];
        this.renderer.appendChild(container, divItem);

        let dividerItem: HTMLDivElement = this.renderer.createElement("div");
        this.renderer.addClass(dividerItem, "dropdown-divider");
        this.renderer.appendChild(container, dividerItem);

        return true;
      } catch (e) {
        console.log(e);
      }

      return false;
    }

  updateMessageFrom(msg: messagereference, parentId: string, routeUrl: string, fromDisplay: string): boolean {
    try {
      if (msg == null) throw "Message Reference is null.";

      let parent: HTMLElement = document.getElementById(parentId);
      if (parent == null) throw "Error: Parent menu (" + parentId + ") item not present in DOM.";

      let strongEl: HTMLElement = document.getElementById("From" + msg.message_key);
      strongEl.textContent = fromDisplay;
      this.renderer.listen(strongEl, 'click', (evt) => {
        var na1 = document.querySelectorAll(".navbar-collapse");
        for (var j = 0; j < na1.length; j++) {
          na1[j].classList.remove("show");
        }

        this.router.navigate([routeUrl]);
      });

      return true;
    } catch (e) {
      console.log(e);
    }

    return false;
  }

    buildRoute(defaultUrl: string, external: boolean) {
      let tourl: string = defaultUrl;
      if (external) {
        if (location.href.indexOf('localhost') >= 0) {
          if (tourl.indexOf("3929") < 0) {
            let EncryptedUserName = encodeURIComponent(this.loginSvc.GetUserName(this.loginSvc.GetSessionUserInfo(), true));
            let tempact = sessionStorage.getItem("g_currentact");
            let act = "&sact=" + (tempact == null ? "" : encodeURIComponent(tempact));
            let temptype = sessionStorage.getItem("g_currentacttype");
            let acttype = "&sacttype=" + (temptype == null || temptype.length == 0 ? "" : temptype.toString());
            let ptact = "&sptact=" + encodeURIComponent(sessionStorage.getItem("g_currentpatient"));
            tourl = ehr_server /*product_server*/ + "/" + "Home/usersignin" + "?suid=" + EncryptedUserName + '&url=' + encodeURIComponent(tourl) + act + acttype + ptact;
          }
        }
        else if (tourl.toLocaleLowerCase().indexOf(location.hostname.toLocaleLowerCase()) < 0
          && tourl.toLocaleLowerCase().indexOf("http") >= 0) {
          return tourl;
        }
        else {
          tourl = "/" + tourl;
        }        
      }
      else {
        tourl = "/" + app_path + tourl;
      }
      return tourl;
    }
    // alerts
    // alertsDropdown
    // alertsBadge
    // alertItems
    /*
        <a class="dropdown-item" href="#">
            <span class="text-success">
                <strong>
                    <i class="fa fa-long-arrow-up fa-fw"></i>Status Update
                </strong>
            </span>
            <span class="small float-right text-muted">11:21 AM</span>
            <div class="dropdown-message small">This is an automated server response message. All systems are online.</div>
        </a>
        <div class="dropdown-divider"></div>
    */

    // insertDropDownDivider(id: alertItems)
}
